import React from "react";
import { Edit3, FileText, Plus, Trash2, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
    DataTable,
    Field,
    INPUT_CLS,
    SearchInput,
    SectionCard,
    SELECT_CLS,
    tl,
} from "./AktueryaUiParts";

const EMPTY_HAK = { ad_soyad: "", yakinlik: "es", cinsiyet: "K", dogum_tarihi: "", pay_adedi: 2 };

export function YaralanmaliForm({ state, setState }) {
    return (
        <>
            <SectionCard title="Kişi & Olay" desc="TRH-2010 bakiye ömür için doğum ve tarihler">
                <Field label="Doğum Tarihi">
                    <Input type="date" className={INPUT_CLS} value={state.dogum_tarihi} onChange={(e) => setState((p) => ({ ...p, dogum_tarihi: e.target.value }))} />
                </Field>
                <div className="grid grid-cols-2 gap-3">
                    <Field label="Kaza Tarihi">
                        <Input type="date" className={INPUT_CLS} value={state.kaza_tarihi} onChange={(e) => setState((p) => ({ ...p, kaza_tarihi: e.target.value }))} />
                    </Field>
                    <Field label="Rapor / Hesap Tarihi">
                        <Input type="date" className={INPUT_CLS} value={state.rapor_tarihi} onChange={(e) => setState((p) => ({ ...p, rapor_tarihi: e.target.value }))} />
                    </Field>
                </div>
                <Field label="Cinsiyet">
                    <select className={SELECT_CLS} value={state.cinsiyet} onChange={(e) => setState((p) => ({ ...p, cinsiyet: e.target.value }))}>
                        <option value="E">Erkek (emeklilik 60)</option>
                        <option value="K">Kadın (emeklilik 58)</option>
                    </select>
                </Field>
            </SectionCard>

            <SectionCard title="Gelir & Maluliyet" desc="Aktif dönem fiili gelir × maluliyet oranı">
                <Field label="Aylık Net Gelir (TL)" hint="Belgelendirilmiş net kazanç — yoksa tahmini band devreye girer">
                    <Input type="number" className={INPUT_CLS} value={state.aylik_net_gelir} onChange={(e) => setState((p) => ({ ...p, aylik_net_gelir: e.target.value }))} placeholder="45000" />
                </Field>
                <div className="grid grid-cols-2 gap-3">
                    <Field label="Maluliyet Oranı %" hint="Min. %10 — altında SİG doğmaz">
                        <Input type="number" className={INPUT_CLS} value={state.maluliyet_orani} onChange={(e) => setState((p) => ({ ...p, maluliyet_orani: e.target.value }))} />
                    </Field>
                    <Field label="Kusur Oranı %">
                        <Input type="number" className={INPUT_CLS} value={state.kusur_orani} onChange={(e) => setState((p) => ({ ...p, kusur_orani: e.target.value }))} />
                    </Field>
                </div>
            </SectionCard>

            <SectionCard title="Mahsup & Ödemeler" desc="Net tazminattan düşülecek kalemler" defaultOpen={false}>
                <div className="grid grid-cols-2 gap-3">
                    <Field label="SGK Mahsubu">
                        <Input type="number" className={INPUT_CLS} value={state.sgk_mahsup} onChange={(e) => setState((p) => ({ ...p, sgk_mahsup: e.target.value }))} />
                    </Field>
                    <Field label="Sigorta Ödemesi">
                        <Input type="number" className={INPUT_CLS} value={state.sigorta_odeme} onChange={(e) => setState((p) => ({ ...p, sigorta_odeme: e.target.value }))} />
                    </Field>
                </div>
            </SectionCard>

            <SectionCard title="Teknik Parametreler" desc="Yargıtay yerleşik: %10 artış / %10 iskonto" defaultOpen={false}>
                <div className="grid grid-cols-2 gap-3">
                    <Field label="Yıllık Artış %">
                        <Input type="number" className={INPUT_CLS} value={state.artis_orani} onChange={(e) => setState((p) => ({ ...p, artis_orani: e.target.value }))} />
                    </Field>
                    <Field label="İskonto %">
                        <Input type="number" className={INPUT_CLS} value={state.iskonto_orani} onChange={(e) => setState((p) => ({ ...p, iskonto_orani: e.target.value }))} />
                    </Field>
                </div>
                <Field label="Pasif Dönem Aylık Gelir" hint="Emeklilik sonrası — varsayılan net asgari ücret">
                    <Input type="number" className={INPUT_CLS} value={state.pasif_aylik_gelir} onChange={(e) => setState((p) => ({ ...p, pasif_aylik_gelir: e.target.value }))} />
                </Field>
                <Field label="Geçmiş Dönem Faiz %" hint="TBK yasal faiz — varsayılan %24">
                    <Input type="number" className={INPUT_CLS} value={state.gecmis_faiz_orani} onChange={(e) => setState((p) => ({ ...p, gecmis_faiz_orani: e.target.value }))} />
                </Field>
                <label className="flex items-center gap-2 text-sm text-slate-300 cursor-pointer">
                    <input
                        type="checkbox"
                        className="rounded border-white/20"
                        checked={state.gecmis_donem_dahil}
                        onChange={(e) => setState((p) => ({ ...p, gecmis_donem_dahil: e.target.checked }))}
                    />
                    Geçmiş dönem (kaza → rapor) + yasal faiz dahil
                </label>
            </SectionCard>

            <SectionCard title="Geçici İş Göremezlik (GİG)" desc="Opsiyonel — kapalıyken mevcut SİG hesabı değişmez" defaultOpen={false}>
                <label className="flex items-center gap-2 text-sm text-slate-300 cursor-pointer mb-3">
                    <input
                        type="checkbox"
                        className="rounded border-white/20"
                        checked={!!state.gig_dahil}
                        onChange={(e) => setState((p) => ({ ...p, gig_dahil: e.target.checked }))}
                    />
                    GİG hesabına dahil et
                </label>
                {state.gig_dahil ? (
                    <div className="space-y-3">
                        <div className="grid grid-cols-2 gap-3">
                            <Field label="GİG Gün Sayısı" hint="OCR veya rapordan">
                                <Input type="number" className={INPUT_CLS} value={state.gig_gun_sayisi} onChange={(e) => setState((p) => ({ ...p, gig_gun_sayisi: e.target.value }))} />
                            </Field>
                            <Field label="GİG Maluliyet %" hint="Boşsa SİG maluliyeti">
                                <Input type="number" className={INPUT_CLS} value={state.gig_maluliyet_orani} onChange={(e) => setState((p) => ({ ...p, gig_maluliyet_orani: e.target.value }))} placeholder={state.maluliyet_orani} />
                            </Field>
                        </div>
                        <label className="flex items-center gap-2 text-xs text-slate-400 cursor-pointer">
                            <input
                                type="checkbox"
                                className="rounded border-white/20"
                                checked={!!state.gig_otomatik_gun}
                                onChange={(e) => setState((p) => ({ ...p, gig_otomatik_gun: e.target.checked }))}
                            />
                            Gün sayısını kaza → rapor tarihi aralığından otomatik al
                        </label>
                    </div>
                ) : null}
            </SectionCard>

            <SectionCard title="Bakım Gideri" desc="Üçüncü kişi / evde bakım — progresif rant PV" defaultOpen={false}>
                <label className="flex items-center gap-2 text-sm text-slate-300 cursor-pointer mb-3">
                    <input
                        type="checkbox"
                        className="rounded border-white/20"
                        checked={!!state.bakim_gideri_dahil}
                        onChange={(e) => setState((p) => ({ ...p, bakim_gideri_dahil: e.target.checked }))}
                    />
                    Bakım gideri hesabına dahil et
                </label>
                {state.bakim_gideri_dahil ? (
                    <Field label="Aylık Bakım Gideri (TL)">
                        <Input type="number" className={INPUT_CLS} value={state.bakim_aylik_gider} onChange={(e) => setState((p) => ({ ...p, bakim_aylik_gider: e.target.value }))} />
                    </Field>
                ) : null}
            </SectionCard>
        </>
    );
}

export function RaporMetaForm({ state, setState }) {
    return (
        <SectionCard title="Rapor & Mahkeme Bilgileri" desc="PDF kapak bloğu — opsiyonel" defaultOpen={false}>
            <Field label="Mahkeme">
                <Input className={INPUT_CLS} value={state.mahkeme} onChange={(e) => setState((p) => ({ ...p, mahkeme: e.target.value }))} placeholder="Ankara 15. Asliye Hukuk Mahkemesi" />
            </Field>
            <Field label="Esas No">
                <Input className={INPUT_CLS} value={state.esas_no} onChange={(e) => setState((p) => ({ ...p, esas_no: e.target.value }))} placeholder="2024/1234 Esas" />
            </Field>
            <div className="grid grid-cols-2 gap-3">
                <Field label="Davacı">
                    <Input className={INPUT_CLS} value={state.davaci} onChange={(e) => setState((p) => ({ ...p, davaci: e.target.value }))} />
                </Field>
                <Field label="Davalı">
                    <Input className={INPUT_CLS} value={state.davali} onChange={(e) => setState((p) => ({ ...p, davali: e.target.value }))} />
                </Field>
            </div>
            <Field label="Müvekkil / Mağdur (PDF)">
                <Input className={INPUT_CLS} value={state.muvekkil} onChange={(e) => setState((p) => ({ ...p, muvekkil: e.target.value }))} />
            </Field>
        </SectionCard>
    );
}

export function OlumluForm({ state, setState }) {
    return (
        <>
            <SectionCard title="Müteveffa" desc="TRH-2010 bakiye ömür ve aktif/pasif dönem">
                <Field label="Doğum Tarihi">
                    <Input type="date" className={INPUT_CLS} value={state.vefat_dogum_tarihi} onChange={(e) => setState((p) => ({ ...p, vefat_dogum_tarihi: e.target.value }))} />
                </Field>
                <div className="grid grid-cols-2 gap-3">
                    <Field label="Kaza / Vefat">
                        <Input type="date" className={INPUT_CLS} value={state.kaza_tarihi} onChange={(e) => setState((p) => ({ ...p, kaza_tarihi: e.target.value }))} />
                    </Field>
                    <Field label="Rapor Tarihi">
                        <Input type="date" className={INPUT_CLS} value={state.rapor_tarihi} onChange={(e) => setState((p) => ({ ...p, rapor_tarihi: e.target.value }))} />
                    </Field>
                </div>
                <Field label="Cinsiyet">
                    <select className={SELECT_CLS} value={state.vefat_cinsiyet} onChange={(e) => setState((p) => ({ ...p, vefat_cinsiyet: e.target.value }))}>
                        <option value="E">Erkek</option>
                        <option value="K">Kadın</option>
                    </select>
                </Field>
            </SectionCard>

            <SectionCard title="Destek Geliri" desc="Gelirin ~%32,5'i desteğin kendi gideri — kalan pay havuzu">
                <Field label="Aylık Net Gelir (TL)">
                    <Input type="number" className={INPUT_CLS} value={state.aylik_net_gelir} onChange={(e) => setState((p) => ({ ...p, aylik_net_gelir: e.target.value }))} />
                </Field>
                <div className="grid grid-cols-2 gap-3">
                    <Field label="Kusur %">
                        <Input type="number" className={INPUT_CLS} value={state.kusur_orani} onChange={(e) => setState((p) => ({ ...p, kusur_orani: e.target.value }))} />
                    </Field>
                    <Field label="Sigorta Ödemesi">
                        <Input type="number" className={INPUT_CLS} value={state.sigorta_odeme} onChange={(e) => setState((p) => ({ ...p, sigorta_odeme: e.target.value }))} />
                    </Field>
                </div>
            </SectionCard>

            <SectionCard title="Hak Sahipleri" desc="Yargıtay pay sistemi: eş 2, çocuk 1">
                <div className="flex items-center justify-between mb-2">
                    <span className="text-xs text-slate-500 flex items-center gap-1">
                        <Users className="h-3 w-3" /> Pay dağılımı
                    </span>
                    <Button type="button" size="sm" variant="ghost" className="h-7 text-xs" onClick={() => setState((p) => ({ ...p, hak_sahipleri: [...p.hak_sahipleri, { ...EMPTY_HAK, pay_adedi: 1 }] }))}>
                        <Plus className="h-3 w-3 mr-1" /> Ekle
                    </Button>
                </div>
                {state.hak_sahipleri.map((h, idx) => (
                    <div key={idx} className="mb-3 p-3 rounded-lg border border-white/10 bg-slate-950/40 space-y-2">
                        <Input placeholder="Ad Soyad" className={INPUT_CLS} value={h.ad_soyad} onChange={(e) => {
                            const arr = [...state.hak_sahipleri];
                            arr[idx] = { ...arr[idx], ad_soyad: e.target.value };
                            setState((p) => ({ ...p, hak_sahipleri: arr }));
                        }} />
                        <div className="grid grid-cols-2 gap-2">
                            <select className={SELECT_CLS} value={h.yakinlik} onChange={(e) => {
                                const arr = [...state.hak_sahipleri];
                                const yk = e.target.value;
                                arr[idx] = { ...arr[idx], yakinlik: yk, pay_adedi: yk === "es" ? 2 : 1 };
                                setState((p) => ({ ...p, hak_sahipleri: arr }));
                            }}>
                                <option value="es">Eş (2 pay)</option>
                                <option value="cocuk">Çocuk (1 pay)</option>
                                <option value="anne">Anne (1 pay)</option>
                                <option value="baba">Baba (1 pay)</option>
                            </select>
                            <Input type="number" placeholder="Pay" className={INPUT_CLS} value={h.pay_adedi} onChange={(e) => {
                                const arr = [...state.hak_sahipleri];
                                arr[idx] = { ...arr[idx], pay_adedi: e.target.value };
                                setState((p) => ({ ...p, hak_sahipleri: arr }));
                            }} />
                        </div>
                        <Input type="date" className={INPUT_CLS} value={h.dogum_tarihi} onChange={(e) => {
                            const arr = [...state.hak_sahipleri];
                            arr[idx] = { ...arr[idx], dogum_tarihi: e.target.value };
                            setState((p) => ({ ...p, hak_sahipleri: arr }));
                        }} />
                        {state.hak_sahipleri.length > 1 ? (
                            <Button type="button" size="sm" variant="ghost" className="text-rose-400 h-7" onClick={() => setState((p) => ({ ...p, hak_sahipleri: p.hak_sahipleri.filter((_, i) => i !== idx) }))}>
                                <Trash2 className="h-3 w-3 mr-1" /> Kaldır
                            </Button>
                        ) : null}
                    </div>
                ))}
            </SectionCard>
        </>
    );
}

export function KayitlarPanel({ kayitlar, kayitId, arama, setArama, onYeni, onLoad, onEdit, onSil }) {
    const filtered = kayitlar.filter((k) => {
        if (!arama.trim()) return true;
        const q = arama.toLowerCase();
        return (k.baslik || "").toLowerCase().includes(q) || (k.hesap_turu || "").includes(q) || String(k.id).includes(q);
    });

    return (
        <div className="space-y-3">
            <div className="flex items-center gap-2">
                <SearchInput value={arama} onChange={setArama} placeholder="Kayıt ara…" />
                <Button type="button" size="sm" variant="outline" onClick={onYeni} className="shrink-0 h-9">
                    <Plus className="h-3 w-3 mr-1" /> Yeni
                </Button>
            </div>
            {filtered.length === 0 ? (
                <div className="text-center py-10 text-slate-500 text-sm">
                    <FileText className="h-8 w-8 mx-auto mb-2 opacity-30" />
                    Kayıt bulunamadı
                </div>
            ) : (
                <div className="space-y-2 max-h-[520px] overflow-y-auto pr-1">
                    {filtered.map((k) => (
                        <div
                            key={k.id}
                            className={`rounded-xl border p-3 transition ${
                                kayitId === k.id ? "border-[#D4AF37]/40 bg-[#D4AF37]/5" : "border-white/10 hover:border-white/20"
                            }`}
                        >
                            <div className="flex gap-2">
                                <button type="button" className="flex-1 text-left min-w-0" onClick={() => onLoad(k.id)}>
                                    <div className="flex items-center gap-2">
                                        <span className="text-[10px] uppercase tracking-wider text-slate-500">
                                            {k.hesap_turu === "olumlu" ? "DYK" : "SİG"}
                                        </span>
                                        <span className="text-[10px] text-slate-600">#{k.id}</span>
                                    </div>
                                    <div className="text-sm text-white truncate mt-0.5">{k.baslik || "—"}</div>
                                    <div className="text-xs text-slate-500 mt-1">{k.tarih?.slice(0, 10)}</div>
                                    <div className="text-sm text-emerald-300/90 mt-2 tabular-nums">Kesin: {tl(k.net_tazminat_kesin ?? k.net_tazminat)}</div>
                                    {k.tahmini_aralik ? (
                                        <div className="text-[10px] text-slate-500 mt-0.5">
                                            Band: {tl(k.tahmini_aralik.min)} – {tl(k.tahmini_aralik.max)}
                                        </div>
                                    ) : null}
                                </button>
                                <div className="flex flex-col gap-1 shrink-0">
                                    <Button type="button" size="sm" variant="ghost" className="h-8 w-8 p-0" onClick={() => onEdit(k.id)}>
                                        <Edit3 className="h-3.5 w-3.5" />
                                    </Button>
                                    <Button type="button" size="sm" variant="ghost" className="h-8 w-8 p-0 text-rose-400" onClick={() => onSil(k.id)}>
                                        <Trash2 className="h-3.5 w-3.5" />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export function CetvelTable({ rows, max = 30 }) {
    const slice = (rows || []).slice(0, max);
    return (
        <DataTable
            columns={[
                { key: "yil", label: "Yıl", render: (r) => r.yil ?? r.sira ?? "—" },
                { key: "donem", label: "Dönem", render: (r) => r.donem_tipi || r.donem || "—" },
                { key: "brut", label: "Yıllık Brüt", align: "right", render: (r) => tl(r.yillik_brut_zarar ?? r.yillik_zarar) },
                { key: "pv", label: "Bugünkü Değer", align: "right", render: (r) => tl(r.bugunku_deger ?? r.pv) },
                { key: "yas", label: "Yaş", align: "right", render: (r) => r.yas ?? "—" },
            ]}
            rows={slice}
        />
    );
}
